import { GAME_END_HEIGHT, GAME_LANE_HEIGHT } from 'app/constants/AppConstants';
import { GAME_SFX_FOOTSTEPS, GAME_SFX_COLLISION } from 'app/constants/GameSFX';

export default class Hero extends Phaser.Sprite {
  constructor({ game, gameState, character = 'apple' }) {
    super(game, 0, 0);

    this.character = character;

    this.costume = this.game.make.spine(0, 0, character + 'Walks');
    this.costume.setAnimationByName(0, 'idle', true);

    this.game = game;
    this.gameState = gameState;

    this.WALK_TIME = 250;

    this.costume.anchor.set(0.5, 1);
    this.addChild(this.costume);

    this.onPosition = true;

    this.state = Hero.STATE_START;

    this.currentRow = 0;
    this.currentColumn = 0;
  }

  goto(x, y) {
    if (this.onPosition && (this.state !== Hero.STATE_LOSE && this.state !== Hero.STATE_WIN)) {
      if (y < this.y) {
        // go up
        this.tween = this.game.add.tween(this).to({ y: y }, this.WALK_TIME, Phaser.Easing.None, true); // Quadratic.InOut
        this.tween.onComplete.add(this.onWalkEnd, this);
        this.costume.setAnimationByName(0, 'walk_fwd', true);
        this.game.sounds.playSFX(GAME_SFX_FOOTSTEPS);
        this.currentRow++;
      } else if (x < this.x) {
        // go left
        this.tween = this.game.add.tween(this).to({ x: x }, this.WALK_TIME, Phaser.Easing.None, true);
        this.tween.onComplete.add(this.onWalkEnd, this);
        this.costume.setAnimationByName(0, 'walk_left', true);
        this.game.sounds.playSFX(GAME_SFX_FOOTSTEPS);
        this.currentColumn--;
      } else {
        // go right
        this.tween = this.game.add.tween(this).to({ x: x }, this.WALK_TIME, Phaser.Easing.None, true);
        this.tween.onComplete.add(this.onWalkEnd, this);
        this.costume.setAnimationByName(0, 'walk_right', true);
        this.game.sounds.playSFX(GAME_SFX_FOOTSTEPS);
        this.costume.scale.x = -1;
        this.costume.update();
        this.costume.updateTransform();
        this.currentColumn++;
      }

      this.onPosition = false;
      this.state = Hero.STATE_WALK;
    }
  }

  onWalkEnd() {
    if (this.state == Hero.STATE_WALK) {
      this.state = Hero.STATE_LAND;
      this.onPosition = true;
      this.costume.scale.x = 1;
      this.costume.setAnimationByName(0, 'idle', true);
      this.tween = null;

      this.gameState.checkLanding(this.currentRow);

      this.game.sounds.stopSFX(GAME_SFX_FOOTSTEPS);
    }
  }

  getWorldBounds() {
    const bounds = this.costume.getBounds();

    // change height
    let h = bounds.height;
    let y = bounds.y;
    let btm = y + h;
    bounds.height = 40;
    bounds.y = btm - bounds.height;

    // fix position
    bounds.x += this.game.camera.view.x;
    bounds.y += this.game.camera.view.y;
    return bounds;
  }

  updatePauseStatus(paused) {
    if (paused) {
      this.costume.state.getCurrent(0).timeScale = 0;
      if (this.tween) this.tween.pause();
    } else {
      this.costume.state.getCurrent(0).timeScale = 1;
      if (this.tween) this.tween.resume();
    }
  }

  handleLose() {
    this.state = Hero.STATE_LOSE;
    this.costume.setAnimationByName(0, 'hit', true);

    // stop walk tween if exist
    if (this.tween) this.tween.stop();

    this.game.sounds.playSFX(this.character + '_lose');
    this.game.sounds.playSFX(GAME_SFX_COLLISION);

    // animate character
    let tween = this.game.add.tween(this).to({ y: '-200' }, 300, Phaser.Easing.Quadratic.Out, true);
    tween.onComplete.add(this.goDown, this);
  }

  goDown() {
    let tween = this.game.add.tween(this).to({ y: '+700' }, 800, Phaser.Easing.Quadratic.In, true);
    tween.onComplete.add(this.onLoseEnd, this);
  }

  onLoseEnd() {
    this.game.controller.showLevelEnd({ win: false });
  }

  handleWin() {
    this.state = Hero.STATE_WIN;
  }

  update() {
    super.update();
    this.costume.update();
  }

  destroy() {
    this.costume.destroy(true);

    this.costume = null;
    this.state = null;

    super.destroy(true);
  }
}

Hero.STATE_START = 'Hero.STATE_START';
Hero.STATE_WALK = 'Hero.STATE_WALK';
Hero.STATE_LAND = 'Hero.STATE_LAND';
Hero.STATE_LOSE = 'Hero.STATE_LOSE';
Hero.STATE_WIN = 'Hero.STATE_WIN';
